export default __webpack_public_path__ + "img/fWdQVDvZ.24810420.svg";